import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import {
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { FiAlertCircle } from "react-icons/fi";
import ButtonCompo from "../../component/ButtonCompo";
import DialogBox from "../../component/DialogBox";
import InputField from "../../component/InputField";
import PaginationBar from "../../component/PaginationBar";
import { FaCheckCircle } from "react-icons/fa";
import { IoAlertCircleSharp } from "react-icons/io5";
import RightDrawer from "../../component/RightDrawer";
import SelectField from "../../component/SelectField";

function PayslipManagement() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [generateDate, setGenerateDate] = useState(0);
  const [selectedGenerateDate, setSelectedGenerateDate] = useState(0);
  const [payslipData, setpayslipData] = useState([]);
  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [monthsArr, setMonthsArr] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const [inHand, setInhand] = useState(0);
  const [selectedSalaryStructure, setSelectedSalaryStructure] = useState([]);
  // tricky part. Always show the data of previous month.
  const [selectedYear, setSelectedYear] = useState(() => {
    if(new Date().getMonth() === 0) {
      return new Date().getFullYear() - 1
    } else {
      return new Date().getFullYear()
    }
  });
  const [selectedMonth, setSelectedMonth] = useState(() => {
    if(new Date().getMonth() === 0) {
      return 11
    } else {
      return new Date().getMonth() - 1
    }
  });

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (employeeData !== null && employeeData?.admin?.payslipEditGenerate === false) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  async function getPayslipGenerateDate() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/get/payslip/generate/date`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
      setGenerateDate(res.data?.data);
      setSelectedGenerateDate(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Date fetch failed");
    } finally {
      setLoading(false);
    }
  }

  async function getPayslipData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/payslip/all/${page}?month=${selectedMonth}&year=${selectedYear}`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data?.data);
      setpayslipData(res.data?.data?.data);
      setTotalPage(res.data?.data?.totalPages);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //edit generate date
  async function editGenerateDate() {
    if (selectedGenerateDate > 30 || selectedGenerateDate < 1) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please choose a valid date");
      return null;
    }
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/edit/payslip/generate/date/${selectedGenerateDate}`,
        method: "put",
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Date updated successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Date update failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // update user salary structure value
  const handleChangeSalary = (index, value) => {
    setSelectedSalaryStructure((prev) => {
      let newArr = [...prev];

      newArr[index] = { ...newArr[index], amount: Number(value) };

      //-------------------------------------------------------------------
      //--------------------Automated Calculations-------------------------
      // update the ctc when user update any value manually
      // let totalCtc = Number(ctc); // Start with basic as the base for CTC calculation
      // newArr.forEach((f) => {
      //   if (f?.isEnable === false) return;

      //   // no calculation required, direct update with amount
      //   let newAmount = Number(f?.amount);

      //   // check deduction
      //   if (f?.isDeduction) {
      //     totalCtc += newAmount;
      //   } else {
      //     totalCtc -= newAmount;
      //   }
      // });
      //-------------------------------------------------------------------

      // Set both the updated array and calculated CTC
      // setBasic(totalCtc);

      return newArr;
    });
  };

  const [payslipLink, setPayslipLink] = useState("");
  // set generate link as button
  const [enableGeneratePayslipView, setEnableGeneratePayslipView] =
    useState(false);

  // re-generate payslip
  async function generatePayslip(userId, month, year) {
    const data = {
      currentMonth: month,
      currentYear: year,
      empId: userId,
      salaryStructure: selectedSalaryStructure,
      inHand: inHand,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/generate/single/payslip`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      setPayslipLink(res.data?.data);
      setEnableGeneratePayslipView(true);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Payslip generate failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // set value for drawer
  function setDrawerValue(data) {
    setInhand(data?.amount);
    setSelectedSalaryStructure(data?.salaryStructure);
    // reset values
    setEnableGeneratePayslipView(false);
    setPayslipLink("");
  }

  const monthDropDownArr = [
    { title: "January", value: 0 },
    { title: "February", value: 1 },
    { title: "March", value: 2 },
    { title: "April", value: 3 },
    { title: "May", value: 4 },
    { title: "June", value: 5 },
    { title: "July", value: 6 },
    { title: "August", value: 7 },
    { title: "September", value: 8 },
    { title: "October", value: 9 },
    { title: "November", value: 10 },
    { title: "December", value: 11 },
  ];

  // console.log(payslipData);

  useEffect(() => {
    getPayslipGenerateDate();
  }, [reload]);

  useEffect(() => {
    getPayslipData();
  }, [reload, selectedMonth, selectedYear, page]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <div>
            <h1 className="text-[30px] font-medium text-left w-full">
              Payslip Management
            </h1>
            <section className="bg-slate-200/50 rounded-[5px] w-fit px-3 py-1 flex items-center mt-3">
              <p className="flex items-center gap-1 text-slate-700 text-[15px]">
                {" "}
                <FiAlertCircle size={16} className="text-slate-600" /> Day of
                Generate Payslip in Every Month :{" "}
                <span className="text-slate-600 font-bold">{generateDate}</span>
              </p>
              <DialogBox
                trigger={
                  <p className="ml-3 uppercase text-blue-500 font-semibold text-[15px] tracking-wider cursor-pointer">
                    Edit
                  </p>
                }
                title="Edit Payslip Generate Date"
                actionButton={
                  <ButtonCompo onClick={editGenerateDate}>Save</ButtonCompo>
                }
              >
                <div>
                  <InputField
                    label="Date"
                    value={selectedGenerateDate}
                    onChange={(event) =>
                      setSelectedGenerateDate(Number(event?.target?.value))
                    }
                  />
                  <p
                    className={`flex items-center gap-1 text-[15px] mt-2 ${
                      selectedGenerateDate > 30 || selectedGenerateDate < 1
                        ? "text-red-600"
                        : "text-slate-600"
                    }`}
                  >
                    <FiAlertCircle
                      size={16}
                      className={`${
                        selectedGenerateDate > 30 || selectedGenerateDate < 1
                          ? "text-red-600"
                          : "text-slate-600"
                      }`}
                    />{" "}
                    Choose a date between{" "}
                    <span className="font-semibold">1 to 30</span>
                  </p>
                </div>
              </DialogBox>
            </section>
          </div>
          <div className="mt-7">
            <div className="mb-5">
              <section className="flex w-[20rem] gap-3">
                <InputField
                  label="Year"
                  value={selectedYear}
                  onChange={(eve) => setSelectedYear(eve?.target?.value)}
                  type="number"
                />
                <SelectField
                  label={"Month"}
                  value={selectedMonth}
                  setValue={(eve) => setSelectedMonth(eve?.target?.value)}
                  valueArray={monthDropDownArr}
                />
              </section>
            </div>
            <Table>
              <TableHead>
                <TableRow className="bg-blue-500">
                  <TableCell className="!text-center !text-white !font-semibold">
                    SL No
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Employee ID
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Name
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Email
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Month
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Year
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Total Earnings
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Total Deduction
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Payslip
                  </TableCell>
                  <TableCell className="!text-center !text-white !font-semibold">
                    Edit Payslip
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="border">
                {payslipData?.map((payslip, index) => (
                  <TableRow
                    className={`${
                      payslip?.payslipUrl === undefined ||
                      payslip?.payslipUrl === ""
                        ? "bg-red-100/80"
                        : ""
                    }`}
                  >
                    <TableCell className="!text-center !font-medium">
                      {index + 1}
                    </TableCell>
                    <TableCell className="!text-center !font-medium">
                      <span className="bg-blue-200/40 px-3 py-2 rounded-full font-medium text-[13px] !text-blue-600">
                        {payslip?.employeeId}
                      </span>
                    </TableCell>
                    <TableCell className="!text-center !font-medium">
                      {payslip?.user?.fullName}
                    </TableCell>
                    <TableCell className="!text-center">
                      {payslip?.user?.profEmail}
                    </TableCell>
                    <TableCell className="!text-center">
                      {monthsArr[payslip?.month]}
                    </TableCell>
                    <TableCell className="!text-center">
                      {payslip?.year}
                    </TableCell>
                    <TableCell className="!text-center">
                      {payslip?.amount}
                    </TableCell>
                    <TableCell className="!text-center">
                      {payslip?.totalDeduction}
                    </TableCell>
                    <TableCell className="!text-center">
                      {payslip?.payslipUrl !== undefined &&
                      payslip?.payslipUrl !== "" ? (
                        <Link to={payslip?.payslipUrl} target="_blank">
                          <ButtonCompo
                            color={"success"}
                            startIcon={<FaCheckCircle size={17} />}
                          >
                            payslip
                          </ButtonCompo>
                        </Link>
                      ) : (
                        <ButtonCompo
                          color={"error"}
                          startIcon={<IoAlertCircleSharp size={17} />}
                        >
                          payslip
                        </ButtonCompo>
                      )}
                    </TableCell>
                    <TableCell className="!text-center">
                      <RightDrawer
                        actionButton={
                          <ButtonCompo
                            variant={"contained"}
                            onClick={() => setDrawerValue(payslip)}
                          >
                            edit
                          </ButtonCompo>
                        }
                      >
                        <div className="p-5">
                          <div className="flex justify-end">
                            <Chip
                              label="Close"
                              color="error"
                              variant="outlined"
                              size="small"
                              className="!cursor-pointer"
                            />
                          </div>
                          <div onClick={(eve) => eve.stopPropagation()}>
                            <section className="text-center space-y-1">
                              <h2 className="text-[18px] text-center font-medium">
                                {payslip?.user?.fullName}
                              </h2>
                              <Chip label={payslip?.user?.role} />
                            </section>
                            <section>
                              <p className="mt-7 text-slate-700">
                                Payslip of{" "}
                                {monthsArr[payslip?.month] +
                                  ", " +
                                  payslip?.year}
                              </p>
                              <div className="grid grid-cols-2 gap-5 mt-5">
                                {selectedSalaryStructure?.map((e, i) =>
                                  e?.isDeduction !== true ? (
                                    <InputField
                                      label={e?.name}
                                      onChange={(e) =>
                                        handleChangeSalary(i, e?.target?.value)
                                      }
                                      value={e?.amount}
                                      key={i}
                                      onClick={(eve) => {
                                        eve?.stopPropagation();
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )
                                )}
                                <InputField
                                  label={"In Hand Amount"}
                                  onChange={(evt) =>
                                    setInhand(evt?.target?.value)
                                  }
                                  value={inHand}
                                  onClick={(eve) => {
                                    eve?.stopPropagation();
                                  }}
                                />
                              </div>
                              <div className="mt-5">
                                <h2 className="font-semibold w-fit text-slate-700">
                                  Deduction Fields
                                </h2>
                                <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-2 gap-10">
                                  {selectedSalaryStructure?.map((e, i) =>
                                    e?.isDeduction === true ? (
                                      <InputField
                                        label={e?.name}
                                        onChange={(e) =>
                                          handleChangeSalary(
                                            i,
                                            e?.target?.value
                                          )
                                        }
                                        value={e?.amount}
                                        key={i}
                                        onClick={(eve) => {
                                          eve?.stopPropagation();
                                        }}
                                      />
                                    ) : (
                                      ""
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="mt-5 flex justify-end">
                                {enableGeneratePayslipView === true ? (
                                  <div className="flex items-center gap-3">
                                    <ButtonCompo
                                      variant={"contained"}
                                      onClick={(eve) => {
                                        eve?.stopPropagation();
                                        generatePayslip(
                                          payslip?.userId,
                                          payslip?.month,
                                          payslip?.year
                                        );
                                      }}
                                    >
                                      Re-Generate Payslip
                                    </ButtonCompo>
                                    <Link
                                      to={payslipLink}
                                      target="_blank"
                                      onClick={(eve) => {
                                        setReload((prev) => !prev);
                                      }}
                                    >
                                      <ButtonCompo variant={"contained"}>
                                        View Payslip
                                      </ButtonCompo>
                                    </Link>
                                  </div>
                                ) : (
                                  <ButtonCompo
                                    variant={"contained"}
                                    onClick={(eve) => {
                                      eve?.stopPropagation();
                                      generatePayslip(
                                        payslip?.userId,
                                        payslip?.month,
                                        payslip?.year
                                      );
                                    }}
                                  >
                                    Generate Payslip
                                  </ButtonCompo>
                                )}
                              </div>
                            </section>
                          </div>
                        </div>
                      </RightDrawer>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <PaginationBar
              attendancePage={page}
              setAttendancePage={setPage}
              totalAttendancePage={totalPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PayslipManagement;
